import { useEffect, useRef } from "react";

import type { ProcessedTshirtImage } from "../../shared/image-processing";

type GuestScanDialogProps = {
  readonly image: ProcessedTshirtImage | null;
  readonly disabled: boolean;
  readonly onSignIn: () => void;
  readonly onDiscard: () => void;
};

export const GuestScanDialog = (props: GuestScanDialogProps) => {
  const dialogRef = useRef<HTMLDialogElement | null>(null);

  useEffect(() => {
    const dialog = dialogRef.current;

    props.image && dialog && !dialog.open
      ? typeof dialog.showModal === "function"
        ? dialog.showModal()
        : dialog.setAttribute("open", "")
      : null;

    return () => {
      dialog?.open
        ? typeof dialog.close === "function"
          ? dialog.close()
          : dialog.removeAttribute("open")
        : null;
    };
  }, [props.image]);

  return props.image ? (
    <dialog className="guest-scan-dialog" ref={dialogRef}>
      <div className="guest-scan-dialog__content">
        <h2>うわ！素敵なTシャツだ！</h2>
        <img src={props.image.objectUrl} alt="スキャンしたTシャツ" />
        <div className="guest-scan-dialog__actions">
          <div className="guest-scan-dialog__save-action">
            <p>ログインしてコレクションを始めよう</p>
            <button
              className="guest-scan-dialog__primary"
              type="button"
              disabled={props.disabled}
              onClick={props.onSignIn}
            >
              Google でログイン
            </button>
          </div>
          <div className="guest-scan-dialog__discard-action">
            <button
              className="guest-scan-dialog__secondary"
              type="button"
              disabled={props.disabled}
              onClick={props.onDiscard}
            >
              保存せずに終了
            </button>
          </div>
        </div>
      </div>
    </dialog>
  ) : null;
};
